const theme = {
  mainColor: '#F97316',
  secondaryColor: '#f9f5e7'
}

export default theme
